import React from 'react';
import styled from 'styled-components';

type ToggleSwitchProps = {
  isOn: boolean;
  onToggle: () => void;
};

export const ToggleSwitch: React.FC<ToggleSwitchProps> = ({ isOn, onToggle }) => {
  return (
    <Wrapper onClick={onToggle} role="switch" aria-checked={isOn}>
      {/* Track: inline style para o background permitir transição CSS */}
      <Track style={{
        background: isOn ? 'linear-gradient(90deg, #92B258, #5292D1)' : 'rgba(255,255,255,0.1)',
        borderColor: isOn ? 'transparent' : 'rgba(255,255,255,0.15)',
      }}>
        {/* Thumb: inline style para o transform — garante que o browser interpola corretamente */}
        <Thumb style={{ transform: isOn ? 'translateX(18px)' : 'translateX(0px)' }} />
      </Track>
      <Label style={{ color: isOn ? '#92B258' : 'rgba(255,255,255,0.28)' }}>
        {isOn ? 'ON' : 'OFF'}
      </Label>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 7px;
  cursor: pointer;
  user-select: none;
`;

/* Transições definidas como estáticas — sem dependência de props para que o browser anime */
const Track = styled.div`
  width: 42px;
  height: 22px;
  border-radius: 11px;
  border: 1px solid transparent;
  box-sizing: border-box;
  padding: 2px;
  display: flex;
  align-items: center;
  transition: background 0.22s ease, border-color 0.22s ease;
  flex-shrink: 0;
`;

const Thumb = styled.div`
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #ffffff;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.45);
  transition: transform 0.22s cubic-bezier(0.34, 1.45, 0.64, 1);
  flex-shrink: 0;
`;

const Label = styled.span`
  font-family: 'Nunito', sans-serif;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.4px;
  min-width: 24px;
  transition: color 0.22s ease;
`;
